
const removeDangerMessage = () => {

    const menuPointTitle = document.getElementsByClassName('admin__add__field__title');
    const menuPointUrl = document.getElementsByClassName('admin__add__field__url');
    menuPointTitle[0].classList.remove('admin__add__field__dangerous');
    menuPointUrl[0].classList.remove('admin__add__field__dangerous');
}
export default removeDangerMessage;